interface DscParamsPayment {
    paymentMethod: string;
    panSuffix: string;
}

export enum DocumentTypes {
    'DSC' = 'DISTANCE_SALE_CONTRACT',
    'PRIVACY_POLICY' = 'PRIVACY_POLICY',
    'TERMS_AND_CONDITIONS' = 'TERMS_AND_CONDITIONS',
}

export const DSC_ACCEPTANCE_PROCESS_ID = '58';

export interface DscParams {
    payments: DscParamsPayment[];
    customerId: number;
    storeId: string;
    locale: string[];
    languageId: string;
}

export interface DscAcceptanceParams {
    customerId: number;
    documentTypes: DocumentTypes[];
    locale: string;
    orderId: number;
    storeId: string;
    languageId: string;
    logonId: string;
    acceptanceProcess: string;
}

export class DscAcceptanceError extends Error {
    public errorKey = 'DSC_ACCEPTANCE_ERROR';

    public errorMessage;

    constructor(message: string) {
        super(message);

        this.errorMessage = message;
    }
}
